import React from 'react';
import { Route } from 'react-router-dom';
import { MarketingLayout } from '../components/marketing/MarketingLayout';
import { HomePage } from '../pages/Marketing/HomePage';
import { ProductsPage } from '../pages/Marketing/ProductsPage';
import { DICOMFilesPage } from '../pages/Marketing/DICOMFilesPage';
import { DICOMCapturePage } from '../pages/Marketing/DICOMCapturePage';
import { ContactPage } from '../pages/Marketing/ContactPage';
import { DocumentationPage } from '../pages/Marketing/DocumentationPage';

// Shared by the SPA (App.jsx) and the build-time prerender (entry-server.jsx).
export const marketingRoutes = (
  <Route path="/" element={<MarketingLayout />}>
    <Route index element={<HomePage />} />
    <Route path="products" element={<ProductsPage />} />
    <Route path="dicomfiles" element={<DICOMFilesPage />} />
    <Route path="dicomcapture" element={<DICOMCapturePage />} />
    <Route path="documentation" element={<DocumentationPage />} />
    <Route path="contact" element={<ContactPage />} />
  </Route>
);
